import { createAsyncAction } from 'typesafe-actions';
import { BuildingTheme } from './types';
import { FailureActionPayload } from '../errors/types';

export const getBuildingTheme = createAsyncAction(
  'GET_BUILDING_THEME_REQUEST',
  'GET_BUILDING_THEME_SUCCESS',
  'GET_BUILDING_THEME_FAILURE',
)<string, BuildingTheme, FailureActionPayload>();
